import * as React from 'react';
import {Badge, Card, Col, OverlayTrigger, Row, Tooltip} from 'react-bootstrap';
import { useState } from 'react';
import { useHistory } from 'react-router';
import SmallModal from "./SmallModal";

const PlayerCard = ({ player, language, t }) => {
    const [open, setOpen] = useState(false);
    const [hovered, setHovered] = useState(false);
    const [restartHovered, setRestartHovered] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const history = useHistory();

    return (
        <>
            <SmallModal show={showModal} onHide={() => setShowModal(false)} title={''} t={t} backdrop="static"
                        keyboard={false} folder={player.folder}/>
            <Card
                key={player._id}
                bg='light'
                text='dark'
                className='mb-sm-4 position-relative'
            >
                <div
                    style={{
                        position: 'absolute',
                        top: '-5px',
                        right: '-7px',
                        transform: `${
                            hovered ? 'scale(1.5,1.5)' : 'scale(1,1)'
                        }`,
                    }}
                >
                    <OverlayTrigger
                        placement='right'
                        overlay={
                            <Tooltip key='right' id={`tooltip-right`}>
                                {t('card_edit')}
                            </Tooltip>
                        }
                    >
                        <i
                            className='fas fa-edit fa-lg'
                            onMouseEnter={() => setHovered(true)}
                            onMouseLeave={() => setHovered(false)}
                            onClick={(e) => {
                                e.preventDefault();
                                history.push(`/players/${player._id}`);
                            }}
                        />
                    </OverlayTrigger>
                </div>

                <Card.Header onClick={() => setOpen(!open)}>
                    <Card.Title className='text-center'>
                        {player.name}
                    </Card.Title>
                    <Card.Subtitle className='text-center text-muted'>
                        {player.email}
                    </Card.Subtitle>
                    {player.isOnline !== undefined && player.isOnline ? (
                        <div className={'text-center pt-2'}>
                            <Row className={''}>
                                <Col className={'d-flex justify-content-start'}>
                                    <i
                                        className='fas fa-undo fa-md invisible'
                                        onClick={(e) => {
                                            e.preventDefault();
                                        }}
                                    />
                                </Col>
                                <Col>
                                    <span className='font-weight-bold text-success pr-2'>ONLINE</span>
                                </Col>
                                <Col className={'d-flex justify-content-end'} style={{
                                    transform: `${
                                        restartHovered ? 'scale(1.3,1.3)' : 'scale(1,1)'
                                    }`,
                                }}>
                                    <OverlayTrigger
                                        placement='right'
                                        overlay={
                                            <Tooltip key='right' id={`tooltip-restart-right`}>
                                                {t('card_restart')}
                                            </Tooltip>
                                        }
                                    >
                                    <div className={'align-content-end'}>
                                        <i
                                            onMouseEnter={() => setRestartHovered(true)}
                                            onMouseLeave={() => setRestartHovered(false)}
                                            className='fas fa-undo fa-md'
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setShowModal(true);
                                            }}
                                        />
                                    </div>
                                    </OverlayTrigger>
                                </Col>

                            </Row>
                        </div>
                    ) : (<div></div>)}

                </Card.Header>

                <Card.Body>
                    <div>
                        <span className='font-weight-bold'>PIN: </span>
                        {player.folder}
                    </div>

                    {player.description}
                </Card.Body>

                <Card.Footer className='pl-2 pr-2 pt-3'>
                    {player.tags.map((tag) => (
                        <Badge
                            key={tag._id}
                            pill
                            variant='dark'
                            className='p-2 mb-1 mr-1'
                        >
                            {tag.name}
                        </Badge>
                    ))}
                </Card.Footer>
            </Card>
        </>
    );
};

export default PlayerCard;
